export const DAILY_ACTIVITY_ADD_REQUEST = 'DAILY_ACTIVITY_ADD_REQUEST'
export const DAILY_ACTIVITY_ADD_SUCCESS = 'DAILY_ACTIVITY_ADD_SUCCESS'
export const DAILY_ACTIVITY_ADD_FAIL = 'DAILY_ACTIVITY_ADD_FAIL'

export const DAILY_ACTIVITY_LIST_REQUEST = 'DAILY_ACTIVITY_LIST_REQUEST'
export const DAILY_ACTIVITY_LIST_SUCCESS = 'DAILY_ACTIVITY_LIST_SUCCESS'
export const DAILY_ACTIVITY_LIST_FAIL = 'DAILY_ACTIVITY_LIST_FAIL'

export const DAILY_ACTIVITY_DETAILS_REQUEST = 'DAILY_ACTIVITY_DETAILS_REQUEST'
export const DAILY_ACTIVITY_DETAILS_SUCCESS = 'DAILY_ACTIVITY_DETAILS_SUCCESS'
export const DAILY_ACTIVITY_DETAILS_FAIL = 'DAILY_ACTIVITY_DETAILS_FAIL'

export const DAILY_ACTIVITY_DELETE_REQUEST = "DAILY_ACTIVITY_DELETE_REQUEST";
export const DAILY_ACTIVITY_DELETE_SUCCESS = "DAILY_ACTIVITY_DELETE_SUCCESS";
export const DAILY_ACTIVITY_DELETE_FAIL = "DAILY_ACTIVITY_DELETE_FAIL";

export const DAILY_ACTIVITY_UPDATE_REQUEST = "DAILY_ACTIVITY_UPDATE_REQUEST";
export const DAILY_ACTIVITY_UPDATE_SUCCESS = "DAILY_ACTIVITY_UPDATE_SUCCESS";
export const DAILY_ACTIVITY_UPDATE_FAIL = "DAILY_ACTIVITY_UPDATE_FAIL";
